/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBazaarvoiceReviewsFragment, BazaarvoiceReviewsFragment, FullBazaarvoiceReviewsFragment} from '@amblique/contentful/app/contentful/fragments/bazaarvoice-reviews';

/**
 * Get a single BazaarvoiceReviews by ID (base - scalars only)
 */
export const getBaseBazaarvoiceReviewsById = gql`
  ${BaseBazaarvoiceReviewsFragment}

  query GetBaseBazaarvoiceReviewsById($id: String!, $locale: String!, $preview: Boolean) {
    bazaarvoiceReviews(id: $id, locale: $locale, preview: $preview) {
      ...BaseBazaarvoiceReviewsFragment
    }
  }
`;

/**
 * Get a single BazaarvoiceReviews by ID (standard - 1 level deep)
 */
export const getBazaarvoiceReviewsById = gql`
  ${BazaarvoiceReviewsFragment}

  query GetBazaarvoiceReviewsById($id: String!, $locale: String!, $preview: Boolean) {
    bazaarvoiceReviews(id: $id, locale: $locale, preview: $preview) {
      ...BazaarvoiceReviewsFragment
    }
  }
`;

/**
 * Get a single BazaarvoiceReviews by ID (full - 2 levels deep)
 */
export const getFullBazaarvoiceReviewsById = gql`
  ${FullBazaarvoiceReviewsFragment}

  query GetFullBazaarvoiceReviewsById($id: String!, $locale: String!, $preview: Boolean) {
    bazaarvoiceReviews(id: $id, locale: $locale, preview: $preview) {
      ...FullBazaarvoiceReviewsFragment
    }
  }
`;

/**
 * Get all BazaarvoiceReviews entries with pagination (base - scalars only)
 */
export const getBaseBazaarvoiceReviewss = gql`
  ${BaseBazaarvoiceReviewsFragment}

  query GetBaseBazaarvoiceReviewss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BazaarvoiceReviewsOrder]
    $where: BazaarvoiceReviewsFilter
    $preview: Boolean
  ) {
    bazaarvoiceReviewsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseBazaarvoiceReviewsFragment
      }
    }
  }
`;

/**
 * Get all BazaarvoiceReviews entries with pagination (standard - 1 level deep)
 */
export const getBazaarvoiceReviewss = gql`
  ${BazaarvoiceReviewsFragment}

  query GetBazaarvoiceReviewss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BazaarvoiceReviewsOrder]
    $where: BazaarvoiceReviewsFilter
    $preview: Boolean
  ) {
    bazaarvoiceReviewsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BazaarvoiceReviewsFragment
      }
    }
  }
`;

/**
 * Get all BazaarvoiceReviews entries with pagination (full - 2 levels deep)
 */
export const getFullBazaarvoiceReviewss = gql`
  ${FullBazaarvoiceReviewsFragment}

  query GetFullBazaarvoiceReviewss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BazaarvoiceReviewsOrder]
    $where: BazaarvoiceReviewsFilter
    $preview: Boolean
  ) {
    bazaarvoiceReviewsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullBazaarvoiceReviewsFragment
      }
    }
  }
`;
